const statusSchemaInit = (schemaType) => {
  let colorSchema;
  switch (schemaType) {
    case "success":
      colorSchema = {
        text: "font-darkGreen",
        background: "bck-green",
        icon: "/assets/orderDetailsIcons/check-circle-colored.svg",
      };
      break;
    case "info":
      colorSchema = {
        text: "font-darkblue",
        background: "bck-blue",
        icon: "/assets/orderDetailsIcons/check-circle-colored.svg",
      };
      break;
    case "error":
      colorSchema = {
        text: "font-darkRed",
        background: "bck-red",
        icon: "/assets/orderDetailsIcons/close-circle-colored.svg",
      };
      break;
    case "warning":
      colorSchema = {
        text: " font-darkYellow",
        background: "bck-yellow",
        icon: "/assets/orderDetailsIcons/info-circle-colored.svg",
      };
      break;
  }
  return colorSchema;
};

const statusColorSchema = {
  Failed: statusSchemaInit("error"),
  Rejected: statusSchemaInit("error"),
  Pending: statusSchemaInit("warning"),
  RequiresAction: statusSchemaInit("warning"),
  Posted: statusSchemaInit("warning"),
  Initiated: statusSchemaInit("warning"),
  Redirection: statusSchemaInit("warning"),
  Initiated: statusSchemaInit("warning"),
  Pending: statusSchemaInit("warning"),
  Approved: statusSchemaInit("success"),
  Settled: statusSchemaInit("success"),
  Received: statusSchemaInit("success"),
  "Awaiting Split Instructions": statusSchemaInit("warning"),
  "Pending Review": statusSchemaInit("warning"),
  "Reviewed": statusSchemaInit("success"),
  "Declined": statusSchemaInit("error"),
};

export { statusColorSchema };
